import { getBasePath } from '@/utils/utils';
import DataBrainBgImg from '@/pages/home/assets/img/databrain-bg.png';
import DashboardBgImg from '@/pages/home/assets/img/dashboard-bg.png';
import IntelligenceBgImg from '@/pages/home/assets/img/intelligence-bg.png';
import OpinionBgImg from '@/pages/home/assets/img/opinion-bg.png';
import GPOPBgImg from '@/pages/home/assets/img/gpop-bg.png';
import DatalabBgImg from '@/pages/home/assets/img/datalab-bg.png';
import DataBrainBgImgEn from '@/pages/home/assets/img/databrain-bg-en.png';
import DashboardBgImgEn from '@/pages/home/assets/img/dashboard-bg-en.png';
import IntelligenceBgImgEn from '@/pages/home/assets/img/intelligence-bg-en.png';
import OpinionBgImgEn from '@/pages/home/assets/img/opinion-bg-en.png';
import GPOPBgImgEn from '@/pages/home/assets/img/gpop-bg-en.png';
import DatalabBgImgEn from '@/pages/home/assets/img/datalab-bg-en.png';
import { PageLogMes } from '@/pages/home/utils/buriedPointCfg';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
//正式环境
export const PROD_HOSTNAME_INTLGAME = 'databrain.intlgame.com';
export const PROD_HOSTNAME_WOA = 'databrain.woa.com';
export const PROD_HOSTNAME_GLOBAL = 'databrain-global.intlgame.com';
//预发布环境
export const PROD_HOSTNAME_PRE = 'databrain-pre.intlgame.com';
export const PROD_HOSTNAME_PRE_WOA = 'databrain-pre.woa.com';
//test环境
export const PROD_HOSTNAME_TEST = 'databrain-test.intlgame.com';
//开发环境
export const PROD_HOSTNAME_DEVIP = '101.32.242.62';
export const PROD_HOSTNAME_DEV = 'databrain-dev.intlgame.com';
export const PROD_HOSTNAME_LOCAL = 'localhost';
/**与后端接口定义的类型 */
export const sysTypeOrEnvType = {
  /**环境类型： 如预发布、正式 -- 用于发送查询参数 */
  env_dev: 0,
  env_test: 1,
  env_pre: 3,
  env_pro: 4,
  /**系统类型： 如经分、情报 -- 用于判断是哪个系统来获取自动弹窗接口*/
  sys_type_dataBrain: 0,
  sys_type_dashbord: 1,
  sys_type_intelligence: 2,
  sys_type_opinions: 3,
  sys_type_globalPedia: 4,
  sys_type_datalab: 5,
};
/**获取环境如预发布/正式 -- 用于发送查询参数 */
export const getSysEvnType = () => {
  const _hostName = location.hostname;
  switch (_hostName) {
    case PROD_HOSTNAME_DEV:
    case PROD_HOSTNAME_DEVIP:
    case PROD_HOSTNAME_LOCAL:
      return sysTypeOrEnvType.env_dev;
    case PROD_HOSTNAME_TEST:
      return sysTypeOrEnvType.env_test;
    case PROD_HOSTNAME_PRE:
    case PROD_HOSTNAME_PRE_WOA:
      return sysTypeOrEnvType.env_pre;
    case PROD_HOSTNAME_INTLGAME:
    case PROD_HOSTNAME_WOA:
    case PROD_HOSTNAME_GLOBAL:
      return sysTypeOrEnvType.env_pro;
    default:
      return sysTypeOrEnvType.env_dev; //默认本地
  }
};

/**获取系统： 如经分 情报 -- 用于判断是哪个系统来获取自动弹窗接口*/
export const getSysType = () => {
  const _pathNameArr = location.pathname.split('/');
  const basePath = getBasePath();
  const sysName =
    basePath?.indexOf(_pathNameArr[1]) > -1 ? _pathNameArr[2] : _pathNameArr[1];
  switch (sysName) {
    case 'home':
      return sysTypeOrEnvType.sys_type_dataBrain;
    case 'dashboard':
    case 'dashboard_pc':
      return sysTypeOrEnvType.sys_type_dashbord;
    case 'intelligence':
    case 'intelligence_detail':
      return sysTypeOrEnvType.sys_type_intelligence;
    case 'opinion':
    case 'opinion_pc':
      return sysTypeOrEnvType.sys_type_opinions;
    case 'g-pop':
      return sysTypeOrEnvType.sys_type_globalPedia;
    case 'datalab':
      return sysTypeOrEnvType.sys_type_datalab;
    default:
      //不是上面的系统则不弹窗
      return -1;
  }
};
/**弹窗左侧菜单列表 */
export const versionListOpts = [
  {
    title: 'Databrain',
    title_cn: '数据大脑',
    icon: 'new-logo',
    sysType: sysTypeOrEnvType.sys_type_dataBrain,
    list: [],
  },
  {
    title: 'Dashboard',
    title_cn: '经分',
    icon: 'merit',
    sysType: sysTypeOrEnvType.sys_type_dashbord,
    list: [],
  },
  {
    title: 'Intelligence',
    title_cn: '情报',
    icon: 'intelligence',
    sysType: sysTypeOrEnvType.sys_type_intelligence,
    list: [],
  },
  {
    title: 'Opinions',
    title_cn: '舆情',
    icon: 'public',
    sysType: sysTypeOrEnvType.sys_type_opinions,
    list: [],
  },
  {
    title: 'G-POP',
    title_cn: '管理看板',
    icon: 'manage-icon',
    sysType: sysTypeOrEnvType.sys_type_globalPedia,
    list: [],
  },
  {
    title: 'Datalab',
    title_cn: '自助分析',
    icon: 'bottle',
    sysType: sysTypeOrEnvType.sys_type_datalab,
    list: [],
  },
];

export const moduleOptions = [
  {
    imgSrcCn: DataBrainBgImg,
    imgSrcEn: DataBrainBgImgEn,
    sysType: sysTypeOrEnvType.sys_type_dataBrain,
  },
  {
    imgSrcCn: DashboardBgImg,
    imgSrcEn: DashboardBgImgEn,
    sysType: sysTypeOrEnvType.sys_type_dashbord,
  },
  {
    imgSrcCn: IntelligenceBgImg,
    imgSrcEn: IntelligenceBgImgEn,
    sysType: sysTypeOrEnvType.sys_type_intelligence,
  },
  {
    imgSrcCn: OpinionBgImg,
    imgSrcEn: OpinionBgImgEn,
    sysType: sysTypeOrEnvType.sys_type_opinions,
  },
  {
    imgSrcCn: GPOPBgImg,
    imgSrcEn: GPOPBgImgEn,
    sysType: sysTypeOrEnvType.sys_type_globalPedia,
  },
  {
    imgSrcCn: DatalabBgImg,
    imgSrcEn: DatalabBgImgEn,
    sysType: sysTypeOrEnvType.sys_type_datalab,
  },
];
export function isJSONFormartStr(str: string) {
  if (typeof str === 'string') {
    try {
      JSON.parse(str);
      return true;
    } catch (err) {
      return false;
    }
  }
}

/**打点信息 */
export const getLogFormSystype = (sysType: number) => {
  switch (sysType) {
    case sysTypeOrEnvType.sys_type_dataBrain:
      return PageLogMes.versionDataBrain;
    case sysTypeOrEnvType.sys_type_dashbord:
      return PageLogMes.versionDashboard;
    case sysTypeOrEnvType.sys_type_intelligence:
      return PageLogMes.versionIntelligence;
    case sysTypeOrEnvType.sys_type_opinions:
      return PageLogMes.versionOpinions;
    case sysTypeOrEnvType.sys_type_globalPedia:
      return PageLogMes.versionGPOP;
    case sysTypeOrEnvType.sys_type_datalab:
      return PageLogMes.versionDatalab;
    default:
      /**6个模块展示时，_sysType=-1,打点为总览信息 */
      return PageLogMes.versionPreview;
  }
};

export interface VersionResType {
  version: VersionItemType;
}

export type VersionItemLocaleType = {
  version_name: string;
  version_content: string;
};
export type VersionItemType = {
  version_name: string;
  version_name_en: string;
  version_content: string;
  version_content_cn: string;
  version_content_en: string;
  release_time: string;
  sys_type: number;
};

export const getTranslateVersionInfo = (
  versionInfo: VersionItemType | null,
  locale: string,
) => {
  const isCN = locale === LANGUAGE_CN;
  if (!versionInfo || typeof versionInfo !== 'object') {
    return null;
  }
  //version_name默认是中文
  const {
    version_name,
    version_name_en,
    version_content,
    version_content_cn,
    version_content_en,
  } = versionInfo;
  if (isCN) {
    return {
      version_name: version_name || version_name_en,
      version_content: version_content_cn || version_content,
      version_name_api: version_name, //用于发送接口
    };
  }
  return {
    version_name: version_name_en || version_name,
    version_content: version_content_en || version_content,
    version_name_api: version_name, //用于发送接口
  };
};
